import React from 'react';
import './RenewalDetails.scss';
import DetailsRow from './DetailRow';

/** @import {InstructionDetail} from '../MaturityOptionsTypes' */

/**
 * @param {{ details: InstructionDetail[] }} props
 */
function DetailsSection({ details }) {
    return (
        <div className={'detailsSection'}>
            {details.map((detail, index) => (
                <DetailsRow
                    key={index}
                    title={detail.title}
                    value={detail.value}
                    additionalInfo={detail.additionalInfo}
                />
            ))}
        </div>
    );
}

export default DetailsSection;